import clsx from 'clsx';
import type React from 'react';

/**
 * A menu item's text, laid out like DropdownLabel, for menus that open inside a form Field.
 * DropdownLabel is a real <label>; inside a Field it takes the Field's control as its target and
 * cancels the click, so the item never runs.
 */
export const DropdownItemText = ({ className, ...props }: React.ComponentProps<'span'>) => (
  <span {...props} data-slot="label" className={clsx(className, 'col-start-2 row-start-1')} />
);
